import { 
    DASHBOARD_PANEL_DELETE_GADGET_OPEN_MODAL,
    DASHBOARD_PANEL_DELETE_GADGET_REQUEST,
    DASHBOARD_PANEL_DELETE_GADGET_RESULT,
} from 'Redux/actionTypes'

export const deleteGadgetOpenModal = (open, data) => ({
    type: DASHBOARD_PANEL_DELETE_GADGET_OPEN_MODAL,
    payload: { open, data }
})

export const deleteGadgetRequest = (id) => ({
    type: DASHBOARD_PANEL_DELETE_GADGET_REQUEST,
    payload: { id }
})

export const deleteGadgetResult = (data) => ({
    type: DASHBOARD_PANEL_DELETE_GADGET_RESULT,
    payload: { data }
})
